import { z } from 'zod';

export const routeFormSchema = z.object({
  name: z
    .string()
    .min(2, '최소 2자 이상')
    .max(64, '최대 64자')
    .regex(/^[a-z0-9-]+$/, '소문자/숫자/하이픈만 허용'),
  serviceId: z.string().min(1, '서비스를 선택하세요').max(64),
  paths: z
    .array(z.string().min(1, '경로를 입력하세요').max(200))
    .min(1, '경로를 최소 1개 입력하세요'),
  methods: z
    .array(z.enum(['GET', 'POST', 'PUT', 'PATCH', 'DELETE', 'HEAD', 'OPTIONS']))
    .optional(),
  headers: z.record(z.string()).optional(),
  stripPath: z.boolean().default(true),
  preserveHost: z.boolean().default(false),
  priority: z.number().int().min(0).max(100).default(0),
  enabled: z.boolean().default(true),
});

export type RouteFormValues = z.infer<typeof routeFormSchema>;
